/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import '../css/index.css'

function Sucess() {
  return (
    <div style={{width:'100%',alignItems:'center',display:'flex'}}>
          <div className="card3">
      <div style={{borderRadius:200, height:200, width:200, backgroundColor:'#F8FAF5', margin:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
        <i className="checkmark i">✓</i>
      </div>
        <h1 className="h1">Success</h1> 
        <p>We received your Hotel Submission request;<br/> AS From Admin Request Approved Wait! we'll be in touch shortly!</p>
      </div>
    </div>
  );
}

export default Sucess;
